import { useEffect, useState } from 'react';

const ContactMap = () => {
  const [frameHeight, setFrameHeight] = useState(false);

  useEffect(() => {
    window.addEventListener('resize', () =>
      window.innerWidth <= 767 ? setFrameHeight(true) : setFrameHeight(false)
    );
  }, []);
  return (
    <section className='DBlock'>
      <iframe
        className='border-none'
        src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3401.887227231367!2d74.31552031448237!3d31.499783455311523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39190476ca66dafd%3A0x95d3c780d67bb61a!2sGarden%20Heights!5e0!3m2!1sen!2s!4v1669287600821!5m2!1sen!2s'
        width='100%'
        height={frameHeight ? '250' : '500'}
        frameborder='0'
        allowfullscreen=''
        loading='lazy'></iframe>
    </section>
  );
};

export default ContactMap;
